// extracted by mini-css-extract-plugin
export default {"main":"Login_main__7mwz5","form_wrapper":"Login_form_wrapper__rJe1B","login_form_forgot":"Login_login_form_forgot__Wq4O8","login_form_button":"Login_login_form_button__DIcRE"};